@if (loading()) {
  <div class="spinner" [neo-loader]="true" [size]="size()" [delayText]="''" [attr.aria-busy]="true"></div>
  <span class="sr-only" role="status">{{ loadingText() }}</span>
} @else {
  <ng-content />
}
